// Reactive accessibility-mode signal, persisted to localStorage (toggled from UserInfoModal).
// When on, desktop adopts mobile's "no hover" interaction model (tap a building -> info overlay
// -> tap an action button, see BuildingInfoOverlay/GameScene/Building) and gains on-screen
// zoom/pan controls (AccessibilityControls.ts), for users who prefer not to rely on hover or
// drag gestures.
const STORAGE_KEY = "accessibility-mode";
function readStored() {
    return localStorage.getItem(STORAGE_KEY) === "true";
}
let current = readStored();
const listeners = new Set();
export function isAccessibilityMode() {
    return current;
}
export function setAccessibilityMode(enabled) {
    if (enabled === current)
        return;
    current = enabled;
    localStorage.setItem(STORAGE_KEY, String(enabled));
    for (const cb of listeners)
        cb(current);
}
// Listeners are never removed — all current call sites are singleton DOM panels/actors that
// live for the app's lifetime (mirrors platform.ts's onMobileChange).
export function onAccessibilityModeChange(cb) {
    listeners.add(cb);
}
